import { AxiosResponse } from 'axios';

export function extractFileNameFromHeader(response: AxiosResponse) {
  const headerWithFileName = response.headers['content-disposition'];
  return headerWithFileName.substring(
    headerWithFileName.indexOf('=') + 1,
    headerWithFileName.length
  );
}

export function triggerDownload(response: AxiosResponse, fileName: string) {
  const link = document.createElement('a');
  const blob = new Blob([response.data]);
  link.download = fileName;
  link.href = URL.createObjectURL(blob);
  link.click();
  URL.revokeObjectURL(link.href);
}
